import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=745b2d94&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import "./Home.vue?vue&type=style&index=0&id=745b2d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745b2d94",
  null
  
)

export default component.exports